import { Form, InputNumber, Popconfirm, Table, Typography, Input, Button, Progress, Card, Space, Modal, Empty } from 'antd';
import { RightOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useState, useRef, useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import ButtonMui from '@mui/material/Button';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { v4 } from 'uuid'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Highlighter from 'react-highlight-words';
import AddSuccess from "./../Manage/AddSuccess";
import AddFail from "./../Manage/AddFail";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux'
import {
  setFile, getFile, setMemberSuccess, getMemberSuccess, setMemberFail, getMemberFail, setObjective, getStyle, getBizID, getObjective, getObjectiveCheck, getFileID, getServices
} from '../../libs/todoSlice'
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from '../../lib/fontColor';
import Tooltip from '@mui/material/Tooltip';
import Address from '../../lib/Address';
import { submitPreRegisterItem } from '../../lib/callAgainPreRegister';
import { toMemberRow, searchRows } from '../../lib/memberRow';
import { buildCAPayload, buildCAFailResponse } from '../../lib/caPayload';
import {
  getEmailRedux,
  setEmailRedux,
  getLoadingRedux,
  setLoadingRedux,
  getShowRedux,
  setShowRedux,
} from "../../libs/sendMailSlice";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  const params = useParams()

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            // {
            //   // required: true,
            //   // message: `Please Input ${title}!`,
            // },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// end edit table
const AddMember = ({ backStep, typeTemplate }) => {
  const [step, setStep] = useState('check');
  const [cookie, setCookie] = useCookies(['account'])
  const dispatch = useDispatch()
  const style = useSelector(getStyle)
  const objective = useSelector(getObjective)
  const objectiveCheck = useSelector(getObjectiveCheck)

  const services = useSelector(getServices)

  // function search top
  const [searchParam, setSearchParam] = useState(null);
  const searchName = () => setData(searchRows(dataDefault, searchParam))
  const clearSearch = () => {
    setSearchParam('')
    setData(dataDefault)
  }

  // end function search top

  // function show member
  const member = useSelector(getFile)
  useEffect(() => {
    const rows = member.map(toMemberRow)
    setData(rows)
    setDataDefault(rows.map((r) => ({ ...r })))
  }, [member])
  // end function show member  

  // tab in success step
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const member_fail = useSelector(getMemberFail)
  useEffect(() => {
    if (member_fail.length > 0) {
      setValue('2')
    }
  }, [member_fail]);
  // end tab in success step
  // function steps progress
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['ตรวจสอบข้อมูล', 'กำลังดำเนินการ', 'สำเร็จ'];
  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor:
          style.primary_color ?? '#053075',
      },
      color: fontColor(style.primary_color)
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor:
          style.primary_color ?? '#053075',
      },
      color: fontColor(style.primary_color)
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));
  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    border: 'solid',
    borderColor: '#F5F5F5',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
    zIndex: 1,
    color: '#E0E0E0',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      backgroundColor:
        '#F3F5FA',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      color: style.primary_color ?? '#053075',
    }),
    ...(ownerState.completed && {
      backgroundColor:
        style.primary_color ?? '#053075',
    }),
  }));
  function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
    const icons = {
      1: <FormatListBulletedIcon />,
      2: <HourglassTopIcon />,
      3: <CheckIcon />,
    };
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }
  // end function steps progress

  //function edit table
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [dataDefault, setDataDefault] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      index: '',
      contract_no: '',
      title_th: '',
      name_th: '',
      surname_th: '',
      name_eng: '',
      surname_eng: '',
      cid: '',
      address: '',
      tel: '',
      mobile: '',
      email: '',
      biz_email: '',
      employee_id: '',
      position: '',
      sub_organization: '',
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async (key, not_set = false) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        dispatch(setFile({
          file: newData
        }))
        if (!not_set) {
          setEditingKey('');
        }
      } else {
        newData.push(row);
        setData(newData);
        dispatch(setFile({
          file: newData
        }))
        if (!not_set) {
          setEditingKey('');
        }
      }
    } catch (errInfo) {
    }
  };

  const handleDelete = (key) => {
    const newData = data.filter((item) => {
      return item.key !== key
    });
    setData(newData);
    dispatch(setFile({
      file: newData
    }))
  };

  const navigate = useNavigate()
  const file = useSelector(getFile)
  const fileID = useSelector(getFileID)
  const successList = useSelector(getMemberSuccess)
  const params = useParams()
  const failList = useSelector(getMemberFail)
  const sendExcelSummary = async () => {
    let obj = [...objective]
    if (objectiveCheck.includes('ra') && !objective.includes('one-id-ra')) {
      obj = [...objective, 'one-id-ra']
    }
    try {
      await axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
        data: {
          _id: fileID,
          total: `${file.length}`,
          success: `${successList.length}`,
          fail: `${failList.length}`,
          successDetail: successList,
          objective: obj,
          objectiveCheck: objectiveCheck,
          failDetail: failList
        }
      })
    } catch (error) {
      if (error.response?.status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }
  // สร้างทีละรายการตาม config กลาง (endpoint/payload อยู่ใน preRegisterConfig.jsx)
  const manageFunction = async () => {
    const ctx = { business_id, file_id: fileID, objective, objectiveCheck, services }
    const success = []
    const fail = []
    for (const [index, item] of member.entries()) {
      const request = { ...item, key: item.key ?? v4() }
      const { ok, response, is_duplicate } = await submitPreRegisterItem(request, ctx)
      ;(ok ? success : fail).push({ request, response, ...(is_duplicate && { is_duplicate }) })
      setcount(index + 1)
    }
    dispatch(setMemberSuccess({ member_success: [...statesuccessone, ...success] }))
    dispatch(setMemberFail({ member_fail: fail }))
    setStateAllOne([...success, ...fail])
  }


  const columns = [
    {
      title: 'ลำดับที่',
      dataIndex: 'index',
      width: 100,
      editable: true,
      fixed: 'left',
      show: true,
      render: (index, __, _) => index
    },
    {
      title: 'เลขที่สัญญา',
      dataIndex: 'contract_no',
      width: 150,
      editable: true,
      hidden: !objective.includes('เลขที่หนังสือสัญญา'),
      fixed: 'left',
      show: services.includes('contract-no'),
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employee_id', //employee_id
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'คำนำหน้า',
      dataIndex: 'title_th',
      width: 150,
      show: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_th">คำนำหน้า</InputLabel>
            <Select
              value={record.title_th}
              labelId='title_th'
              label="คำนำหน้า"
              onChange={(e) => {
                let tempData = [...data]
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                const title_en = title_en_list[title_th_list.indexOf(e.target.value)]
                tempData[record.index - 1].title_th = e.target.value
                tempData[record.index - 1].title_en = title_en
                setData(tempData)
              }}
            >
              <MenuItem value={'นาย'}>นาย</MenuItem>
              <MenuItem value={'นางสาว'}>นางสาว</MenuItem>
              <MenuItem value={'นาง'}>นาง</MenuItem>
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'เด็กชาย'}>เด็กชาย</MenuItem>
                )
              }
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'เด็กหญิง'}>เด็กหญิง</MenuItem>
                )
              }
            </Select>
          </FormControl>
        ) : (record.title_th)
      }
    },
    {
      title: 'คำนำหน้า (ภาษาอังกฤษ)',
      dataIndex: 'title_en',
      width: 150,
      show: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
            <Select
              value={record.title_en}
              labelId='title_en'
              label="คำนำหน้า (ภาษาอังกฤษ)"
              onChange={(e) => {
                let tempData = [...data]
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                const title_th = title_th_list[title_en_list.indexOf(e.target.value)]
                tempData[record.index - 1].title_en = e.target.value
                tempData[record.index - 1].title_th = title_th
                setData(tempData)
              }}
            >
              <MenuItem value={'Mr'}>Mr</MenuItem>
              <MenuItem value={'Miss'}>Miss</MenuItem>
              <MenuItem value={'Mrs'}>Mrs</MenuItem>
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'Master'}>Master</MenuItem>
                )
              }
            </Select>
          </FormControl>
        ) : (record.title_en)
      }
    },
    {
      title: 'คำนำหน้านาม',
      dataIndex: 'title_special_th',
      width: 200,
      show: objective.includes('Pre-register') && services.includes('medical-pre-register'),
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_special_th">คำนำหน้านาม</InputLabel>
            <Select
              value={record.title_special_th}
              labelId='title_special_th'
              label="คำนำหน้านาม"
              onChange={(e) => {
                record.title_special_th = e.target.value;
                save(record.key, true)
              }}
            >
              <MenuItem value={'นายแพทย์'}>นายแพทย์</MenuItem>
              <MenuItem value={'แพทย์หญิง'}>แพทย์หญิง</MenuItem>
              <MenuItem value={'ทันตแพทย์ชาย'}>ทันตแพทย์ชาย</MenuItem>
              <MenuItem value={'ทันตแพทย์หญิง'}>ทันตแพทย์หญิง</MenuItem>
              <MenuItem value={'เภสัชกรหญิง'}>เภสัชกรหญิง</MenuItem>
              <MenuItem value={'เภสัชกรชาย'}>เภสัชกรชาย</MenuItem>
            </Select>
          </FormControl>
        ) : (record.title_special_th)
      }
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาไทย)',
      dataIndex: 'special_title_th',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาอังกฤษ)',
      dataIndex: 'special_title_eng',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ฉายา (ไทย)',
      dataIndex: 'nickname_th',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ฉายา (อังกฤษ)',
      dataIndex: 'nickname_eng',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },

    {
      title: 'เลขประจำตัวบุคลากรทางการแพทย์',
      dataIndex: 'employee_id',
      width: 180,
      editable: true,
      hidden: !objective.includes('Pre-register'),
      show: services.includes('medical-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อ (ภาษาไทย)',
      dataIndex: 'name_th',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อกลาง (ภาษาไทย)',
      dataIndex: 'middle_name_th',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุล (ภาษาไทย)',
      dataIndex: 'surname_th',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อ (ภาษาอังกฤษ)',
      dataIndex: 'name_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อกลาง (ภาษาอังกฤษ)',
      dataIndex: 'middle_name_eng',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุล (ภาษาอังกฤษ)',
      dataIndex: 'surname_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ประเภทบัตร',
      dataIndex: 'id_card_type',
      width: 180,
      show: (services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register')) || (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')) || objective.includes('edu-officer-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
            <Select
              value={record.id_card_type}
              labelId='id_card_type'
              label="ประเภทบัตร"
              onChange={(e) => {
                let tempData = [...data]
                tempData[record.index - 1].id_card_type = e.target.value
                setData(tempData)
              }}
            >
              <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
              <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
              {
                objective.includes('edu-student-pre-register') &&
                <MenuItem value={'G_CODE'}>G_CODE</MenuItem>

              }
            </Select>
          </FormControl>
        ) : (record.id_card_type)
      }
    },
    {
      title: 'เลขประจำตัวประชาชน',
      dataIndex: 'cid',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ระดับการศึกษา',
      dataIndex: 'degree',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'คณะ',
      dataIndex: 'faculty',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'Major (สาขา/ภาควิชา)',
      dataIndex: 'major',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'Minor (ถ้ามี)',
      dataIndex: 'minor',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'สถานะการศึกษา',
      dataIndex: 'status',
      width: 180,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="status">คำนำหน้า</InputLabel>
            <Select
              value={record.status}
              labelId='status'
              label="คำนำหน้า"
              onChange={(e) => {
                record.status = e.target.value;
                save(record.index, true)
              }}
            >
              <MenuItem value={'กำลังศึกษา'}>กำลังศึกษา</MenuItem>
              <MenuItem value={'สำเร็จการศึกษา'}>สำเร็จการศึกษา</MenuItem>
              <MenuItem value={'ลาออก'}>ลาออก</MenuItem>
              <MenuItem value={'พ้นสภาพการศึกษา'}>พ้นสภาพการศึกษา</MenuItem>
              <MenuItem value={'อื่นๆ'}>อื่นๆ</MenuItem>
            </Select>
          </FormControl>
        ) : (record.status)
      }
    },
    {
      title: 'วันเกิด (ปปปป-ดด-วว)',
      dataIndex: 'birth_date',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('Pre-register') || objective.includes('edu-officer-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_) => {
        return <>{_}</>
      }
    },
    {
      title: 'รหัสนักศึกษา',
      dataIndex: 'student_id',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'password',
      dataIndex: 'password',
      width: 180,
      editable: true,
      show: (objective.includes('edu-teacher-pre-register')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

    },
    {
      title: 'ที่อยู่ของหน่วยงาน',
      dataIndex: 'address',
      width: 400,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('เลขที่หนังสือสัญญา') || objective.includes('import-excel-rama')),
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 400,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: !(services.includes('ca') || services.includes('contract-no')) && !objective.includes('CA'),
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')),
    },
    {
      title: 'บ้านเลขที่',
      dataIndex: 'house_no',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ห้องที่',
      dataIndex: 'room_no',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'หมู่ที่',
      dataIndex: 'moo',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชั้นที่',
      dataIndex: 'floor',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ถนน',
      dataIndex: 'street',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อาคาร',
      dataIndex: 'building_name',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'หมู่บ้าน',
      dataIndex: 'alley',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ตำบล',
      dataIndex: 'sub_district',
      width: 150,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')),
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="sub_district">ตำบล</InputLabel>
            <Select
              value={record.sub_district}
              labelId='sub_district'
              label="ตำบล"
              onChange={(e) => {
                let tempData = [...data]
                tempData[record.index - 1].sub_district = e.target.value
                setData(tempData)
              }}
            >
              {Address.getSubDistrict(record.province, record.district).map((sub_district, key) => {
                return <MenuItem key={key} value={sub_district}>{sub_district}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.sub_district)
      }
    },
    {
      title: 'อำเภอ',
      dataIndex: 'district',
      width: 150,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')),
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="district">อำเภอ</InputLabel>
            <Select
              value={record.district}
              labelId='district'
              label="อำเภอ"
              onChange={(e) => {
                let tempData = [...data]
                tempData[record.index - 1].district = e.target.value
                setData(tempData)
              }}
            >
              {Address.getDistrict(record.province).map((district, key) => {
                return <MenuItem key={key} value={district}>{district}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.district)
      }
    },
    {
      title: 'จังหวัด',
      dataIndex: 'province',
      width: 150,
      // editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')),
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="id_card_type">จังหวัด</InputLabel>
            <Select
              value={record.province}
              labelId='province'
              label="จังหวัด"
              onChange={(e) => {
                let tempData = [...data]
                tempData[record.index - 1].province = e.target.value
                setData(tempData)
              }}
            >
              {Address.getProvince().map((province, key) => {
                return <MenuItem key={key} value={province}>{province}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.province)
      }
    },
    {
      title: 'รหัสไปรษณีย์',
      dataIndex: 'zipcode',
      width: 150,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register')),
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="zipcode">รหัสไปรษณีย์</InputLabel>
            <Select
              value={record.zipcode}
              labelId='zipcode'
              label="รหัสไปรษณีย์"
              onChange={(e) => {
                let tempData = [...data]
                tempData[record.index - 1].zipcode = e.target.value
                setData(tempData)
              }}
            >
              {Address.getZipCode(record.province, record.district, record.sub_district).map((zipcode, key) => {
                return <MenuItem key={key} value={zipcode}>{zipcode}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.zipcode)
      }
    },
    {
      title: 'วันที่เริ่มการศึกษา',
      dataIndex: 'start_year',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'วันที่จบการศึกษา',
      dataIndex: 'end_year',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์',
      dataIndex: 'tel',
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (tel, record) => {
        if (tel === '-' && !!record.mobile) {
          return record.mobile
        } else {
          return tel
        }
      }
      // ...getColumnSearchProps('tel'),
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobile',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('mobile'),
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      width: 250,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('email'),
    },
    {
      title: 'อีเมลองค์กร',
      dataIndex: 'biz_email',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ตำแหน่งของเจ้าของใบรับรอง',
      dataIndex: 'position',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
      // ...getColumnSearchProps('position'),
    },
    {
      title: 'ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'sub_organization',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
      // ...getColumnSearchProps('sub_organization'),
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 350,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 350,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes('Pre-register')
    },
    {
      title: 'ชื่อองค์กร',
      dataIndex: 'organization',
      width: 350,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes('Pre-register')
    },
    {
      title: 'เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล',
      dataIndex: 'tax_id',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: services.includes('ca') && objective.includes('CA') && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'แผนก',
      dataIndex: 'department',
      editable: true,
      width: 120,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra'))
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      editable: true,
      width: 120,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra'))
    },
    // {
    //   title: 'age',
    //   dataIndex: 'age',
    //   width: '15%',
    //   editable: true,
    // },
    {
      title: 'operation',
      dataIndex: 'operation',
      width: 200,
      fixed: 'right',
      show: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              type='primary'
              onClick={() => save(record.key)}
              style={{
                marginRight: 8,
                background: '#53BE35'
              }}
            >
              บันทึก
            </Button>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>ยกเลิก</a>
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link /* disabled={editingKey !== ''} */ onClick={() => edit(record)}>
              <ModeEditOutlinedIcon style={{ color: '#053075' }} />
            </Typography.Link>
            {data.length >= 1 ? (
              <Popconfirm title="ต้องการลบข้อมูลนี้ใช่หรือไม่"

                onConfirm={() =>
                  handleDelete(record.key)
                }>
                <DeleteOutlinedIcon style={{ cursor: 'pointer', color: 'red' }} />
              </Popconfirm>
            ) : null
            }
          </>
        );
      },
    },
  ].filter(head => !head.hidden && head.show);
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ||
          col.dataIndex === 'index' ||
          col.dataIndex === 'no' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // end edit table

  // function register member
  const importMemberSuccess = useSelector(getMemberSuccess)
  const importMemberFail = useSelector(getMemberFail)
  const [countCA, setcountCA] = useState(0)
  const [caTotal, setCATotal] = useState(0)
  const [count, setcount] = useState(0)
  const statesuccessone = useSelector(getMemberSuccess)
  const statefailone = useSelector(getMemberFail)
  const [stateAllOne, setStateAllOne] = useState([])
  const [statesuccessca, setStateSuccessCA] = useState([])
  const [statefailca, setStateFailCA] = useState([])
  const business_id = useSelector(getBizID)
  const biz_id = useSelector(getBizID)
  const bizID = useParams()

  const sendEmailRA = async () => {
    setLoading(true)
    try {
      await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/send-mail-oneid-ra?biz_id=${biz_id}&file_id=${fileID}`,
      })
    } catch (error) {
      console.error('Failed to send RA email:', error.response?.data ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const [modalbeforeSuccess, setModalBeforeSuccess] = useState(false);
  const didMountRef = useRef(false);
  const caStartedRef = useRef(false);
  const completionScheduledRef = useRef(false);
  useEffect(() => {
    if (step !== 'success') {
      if (objective.includes('CA') || objective.includes('import-excel-rama')) {
        if (caTotal > 0 && countCA >= caTotal && !completionScheduledRef.current) {
          completionScheduledRef.current = true
          setActiveStep(2)
          setTimeout(() => {
            setStep('success')
            setModalBeforeSuccess(true)
            setActiveStep(3)
          }, 1500)
        } else if (statesuccessone.length === 0 && statefailone.length === stateAllOne.length && stateAllOne.length !== 0 && !completionScheduledRef.current) {
          completionScheduledRef.current = true
          setActiveStep(2)
          setTimeout(() => {
            setStep('success')
            setModalBeforeSuccess(true)
            setActiveStep(3)
          }, 1500)
        }
      } else {
        if (statesuccessone.length + statefailone.length === member.length && member.length !== 0) {
          setActiveStep(2)
          setTimeout(() => {
            setStep('success')
            setModalBeforeSuccess(true)
            setActiveStep(3)
          }, 1500)
        }
      }
    }
    didMountRef.current = true;
  }, [countCA, caTotal, statesuccessone, statefailone, stateAllOne])
  useEffect(() => {
    const performActions = async () => {
      if (modalbeforeSuccess) {
        await sendExcelSummary();
        if (objectiveCheck.includes('ra')) {
          sendEmailRA();
        }
      }
    };

    performActions();
    // if (modalbeforeSuccess) {
    //   await sendExcelSummary()
    //   if (modalbeforeSuccess && objectiveCheck.includes('ra')) {
    //     if (objectiveCheck.includes('ra')) {
    //       sendEmailRA();
    //     }
    //   }
    // }
  }, [modalbeforeSuccess])

  useEffect(() => {
  }, [step])

  const createCA = async () => {
    let prepare_ca_success = []
    let prepare_ca_fail = []
    setCATotal(statesuccessone.length)
    if (statesuccessone.length === 0) {
      setActiveStep(2)
      setTimeout(() => {
        setStep('success')
        // setModalBeforeSuccess(true)
        setActiveStep(3)
      }, 1500)
    } else {
      for (const index of statesuccessone.keys()) {
        // รายการ is_duplicate ("มีใน business แล้ว") response เป็น error body ไม่มี data.account_id
        if (!statesuccessone[index].response?.data?.account_id) {
          setcountCA(index + 1)
          continue
        }
        try {
          const { data } = await axios({
            method: 'POST',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/ca`,
            data: buildCAPayload(statesuccessone[index], business_id)
          })
          prepare_ca_success.push({
            request: statesuccessone[index].request,
            response: statesuccessone[index].response,
            caResponse: data,
          })
        } catch (error) {
          prepare_ca_fail.push({
            request: statesuccessone[index].request,
            response: buildCAFailResponse(error),
            retryType: 'ca',
            is_ca_fail: true,
            account_id: statesuccessone[index].response.data.account_id,
            oneIdResponse: statesuccessone[index].response
          })
        } finally {
          setcountCA(index + 1)
        }
      }
      setStateSuccessCA(prepare_ca_success)
      setStateFailCA(prepare_ca_fail)
      if (prepare_ca_fail.length > 0) {
        const caFailKeys = new Set(prepare_ca_fail.map(({ request }) => request.key))
        dispatch(setMemberSuccess({
          member_success: statesuccessone.filter(({ request }) => !caFailKeys.has(request.key))
        }))
        dispatch(setMemberFail({
          member_fail: [...statefailone, ...prepare_ca_fail]
        }))
      }
    }
  }

  useEffect(() => {
    if (!caStartedRef.current && stateAllOne.length === member.length && (objective.includes('CA') || objective.includes('import-excel-rama'))) {
      caStartedRef.current = true
      createCA()
    }
  }, [
    statesuccessone,
    stateAllOne
  ])
  // end function register member

  const alertManagement = () => {
    let message = `One ID`
    if (objective.includes('CA') || objective.includes('import-excel-rama')) {
      message += ', CA'
    }
    if (objective.includes('เลขที่หนังสือสัญญา')) {
      message += ' และเลขที่หนังสือสัญญา'
    }

    if (objective.includes('edu-student-pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับ นักเรียน/นักศึกษา'
    }

    if (objective.includes('edu-teacher-pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับ ครู/อาจารย์'
    }

    if (objective.includes('edu-officer-pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับ บุคลากร'
    }
    if (objective.includes('Pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับบุคคลากรทางการแพทย์'
    }

    if (importMemberSuccess.length !== 0) {
      return (
        <>
          สร้าง {message} แล้ว <br />
          {importMemberSuccess.length} รายการ จาก {file.length} รายการ
        </>
      )
    } else {
      return (
        <>
          ไม่มีการสร้าง {message}
        </>
      )
    }

  }


  const customLocale = {
    emptyText: (<Empty description="ไม่มีข้อมูล" />)
  };
  return (
    <>
      <Row>
        <Col className="d-flex justify-content-start">
          <h3
            style={{
              margin: 0,
              padding: 0,
              border: 'none',
              cursor: 'pointer'
            }}
            onClick={() => {
              backStep()
            }}
          >
            <ArrowBackIosIcon />
            เพิ่มรายชื่อ
          </h3>
        </Col>
      </Row>
      {/* ui steps progress */}
      <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
        <Stack sx={{ width: '100%' }} spacing={4}>
          <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
            {steps.map((label, key) => (
              <Step key={key}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Stack>
      </Row>
      {/* end ui steps progress */}
      {
        {
          "check": (
            <>
              {/* ui search */}
              <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Col xl={12} lg={12} md={6} sm={12} xs={12}>
                  <h5>ค้นหา</h5>
                </Col>
                <Col xl={5} lg={6} md={6} sm={12} xs={12}>
                  <Tooltip title="ค้นหาด้วยชื่อ-นามสกุล เลขบัตรประจำตัวประชาชน หรือ เลขที่หนังสือสัญญา">
                    <Input.Group compact>
                      <Input
                        value={searchParam}
                        size="large"
                        style={{
                          width: 'calc(100% - 40px)',
                        }}
                        placeholder="ค้นหาด้วยชื่อ-นามสกุล เลขบัตรประจำตัวประชาชน หรือ เลขที่หนังสือสัญญา"
                        onChange={({ target }) => {
                          setSearchParam(target.value);
                        }}
                        onPressEnter={() => {
                          searchName()
                        }}
                        suffix={
                          // searchParam &&
                          <CloseOutlined
                            onClick={() => {
                              clearSearch()
                            }}
                            style={{
                              color: 'rgba(0,0,0,.45)',
                            }}
                          />
                        }
                      />
                      <Button
                        icon={<SearchOutlined />}
                        size="large"
                        style={{ borderRadius: '0px 4px 4px 0px' }}
                        onClick={() => {
                          searchName()
                        }}
                      />
                    </Input.Group>
                  </Tooltip>
                </Col>
              </Row>
              {/* end ui search */}
              {/* ui table */}
              <Form form={form} component={false}>
                <Table
                  locale={customLocale}
                  components={{
                    body: {
                      cell: EditableCell,
                    },
                  }}
                  bordered
                  dataSource={data}
                  columns={mergedColumns}
                  rowClassName="editable-row"
                  pagination={{
                    onChange: cancel,
                  }}
                  scroll={{
                    x: 1400,
                    y: 400,
                  }}
                />
              </Form>
              {/* end ui table */}
              <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Col className='d-flex justify-content-start'>
                  <ButtonMui
                    sx={!!style.secondary_color && {
                      borderColor: `${style.secondary_color} !important`,
                      color: `${style.secondary_color} !important`,
                      border: ' 1px solid'
                    }}
                    size='large'
                    onClick={() => {
                      backStep()
                      setActiveStep(0)
                    }}>
                    ยกเลิก
                  </ButtonMui>
                </Col>
                <Col className='d-flex justify-content-end'>
                  <ButtonMui
                    sx={!!style.secondary_color && {
                      background: `${style.secondary_color} !important`,
                      color: fontColor(style.secondary_color)
                    }}
                    size='large'
                    hidden={member.length === 0}
                    onClick={() => {
                      manageFunction()
                      setStep('pending')
                      setActiveStep(1)
                    }}>
                    ดำเนินการสร้าง <RightOutlined />
                  </ButtonMui>
                </Col>
              </Row>
            </>
          ),
          "pending": (
            <>
              <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Col className='d-flex justify-content-center'>
                  <Progress
                    type="circle"
                    percent={(count / file.length) * 100}
                    strokeColor={{
                      '0%': '#86DB0A',
                      '25%': '#A4E311',
                      '50%': '#F0F420',
                      '70%': '#FFCC01',
                      '100%': '#FF9801',
                    }}
                    format={(percent) => <> {file.length} <br /><span style={{ fontSize: '12px' }}>รายการทั้งหมด</span> </>}
                  />
                </Col>
              </Row>
              {typeTemplate.map((type, key) => {
                if (type == 'One ID') {
                  return (
                    <Row key={key} style={{ marginBottom: '20px', marginTop: '20px' }}>
                      <Col className='d-flex justify-content-center'>
                        <Card style={{ width: '100%', boxShadow: '4px 4px 16px rgba(5, 48, 117, 0.12)' }}>
                          <div className='row'>
                            <div className='col' style={{ textAlign: 'start' }}>
                              <b>สร้างรายชื่อ One ID</b>
                            </div>
                            <div className='col' style={{ textAlign: 'end' }}>
                              <CloseOutlined />
                            </div>
                          </div>
                          <p style={{ paddingTop: '20px' }}>
                            <Progress percent={parseInt((count / file.length) * 100)} status="active" strokeColor='#53BE35' />
                          </p>
                        </Card>
                      </Col>
                    </Row>
                  )
                }
                else if (type == 'CA' || type == 'import-excel-rama') {
                  return (
                    <Row key={key} style={{ marginBottom: '20px', marginTop: '20px' }}>
                      <Col className='d-flex justify-content-center'>
                        <Card style={{ width: '100%', boxShadow: '4px 4px 16px rgba(5, 48, 117, 0.12)' }}>
                          <div className='row'>
                            <div className='col' style={{ textAlign: 'start' }}>
                              <b>สร้างรายชื่อ CA</b>
                            </div>
                            <div className='col' style={{ textAlign: 'end' }}>
                              <CloseOutlined />
                            </div>
                          </div>
                          <p style={{ paddingTop: '20px' }}>
                            {(count / file.length) * 100 === 100 ?
                              <Progress percent={(countCA / file.length) * 100} status="active" strokeColor='#53BE35' />
                              :
                              'รอรายการก่อนหน้าดำเนินการเสร็จ'
                            }
                          </p>
                        </Card>
                      </Col>
                    </Row>
                  )
                }
              })}
            </>
          ),
          "success": (
            <>
              <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                        TabIndicatorProps={{
                          sx: !!style.secondary_color && {
                            backgroundColor: `${style.secondary_color} !important`,
                            color: fontColor(style.secondary_color)
                          }
                        }}>
                        <Tab label={`รายการที่สำเร็จ (${importMemberSuccess.length})`} value="1" />
                        <Tab label={`รายการที่ไม่สำเร็จ (${importMemberFail.length})`} value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <AddSuccess
                        memberOneSuccess={statesuccessone}
                      // memberCASuccess={memberCASuccess}
                      />
                    </TabPanel>
                    <TabPanel value="2">
                      <AddFail />
                    </TabPanel>
                  </TabContext>
                </Box> 
              </Row>
              <Modal
                title={importMemberSuccess.length != 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
                centered
                open={modalbeforeSuccess}
                onOk={() => setModalBeforeSuccess(false)}
                onCancel={() => setModalBeforeSuccess(false)}
                footer={null}
              >
                <Row>
                  <Col className='d-flex justify-content-center'>
                    {importMemberSuccess.length != 0 ?
                      <CheckIcon style={{
                        background: '#53BE35',
                        borderRadius: '50%',
                        fontSize: '50px',
                        color: '#fff',
                        padding: '10px'
                      }} />
                      :
                      <CloseIcon style={{
                        background: '#F37959',
                        borderRadius: '50%',
                        fontSize: '50px',
                        color: '#fff',
                        padding: '10px'
                      }} />
                    }
                  </Col>
                </Row>
                <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
                  <Col className='d-flex justify-content-center text-center'>
                    {alertManagement()}
                  </Col>
                </Row>
              </Modal>
            </>
          ),
        }[step]
      }
    </>
  );
};
export default AddMember;